/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

window.onload = function(){
  var $ = jQuery;
  $("[name=id]").on('change', function(e){
    var value = $(this).find("option:selected").text();
    var selected = value.substring(0, value.lastIndexOf("-")).trim();
    var isMultipleOptions = $('.original-product-form-options').length > 1;

    if(isMultipleOptions){
      if(selected.indexOf('/') > -1){
        var options = selected.split('/');
        console.log('options',options);
        for(var i = 0; i<options.length; i++){
          var optionName = options[i].trim();
          $(".Popover__ValueList").find("[data-value='"+optionName+"']").trigger('click');
        }
      }
    } else {
      $(".Popover__ValueList").find("[data-value='"+selected+"']").trigger('click');
    }
  })
};


function myFunction() {
  // Get the checkbox
  var checkBox = document.getElementById("show-note");
  // Get the output text
  var text = document.getElementById("cart-note");

  // If the checkbox is checked, display the output text
  if (checkBox.checked == true){
    text.style.display = "block";
  } else {
    text.style.display = "none";
    text.value = "";
  }
}
